// extracted by mini-css-extract-plugin
module.exports = {"statusLabel":"_2MkRisWMzTcIVbNUaV9RaH","availableColor":"_2sM_vPcNHOHv9S9-7KXfDf","restrictedColor":"_1-GH03-NbF_GwLKR4gmJ0J","unavailableColor":"wj5koI6Rv7dROsyuDIYNt"};